var exports = {
  "O3": "ItemPaging__q37O0h",
  "rc": "ColumnPaging__n_oOSF",
  "VR": "RowPaging__8xYELO",
  "LJ": "RowPagingLoading__wPG3zq",
  "kb": "Ghost__o_xfIP",
  "w4": "ColumnGhost__9rI0BA",
  "YO": "RowGhost__lfV21c",
  "ml": "CardGhost__FSq9MO",
  "LX": "Truncated__mcu5Xe",
  "aF": "ColumnsTruncated__SmTIc6",
  "WP": "RowsTruncated__LxxKmg",
};

module.exports = exports;
